/* eslint-disable max-lines */ // ¯\_(ツ)_/¯
import PropTypes from "prop-types";
import { createElement, forwardRef, Fragment } from "react";
import styled from "styled-components";

import { styles } from "./styles";

function inputElementPragma(Component, props, children) {
  const { type } = props;
  switch (type) {
    case "checkbox": {
      return createElement(
        Fragment,
        null,
        createElement(Component, props),
        createElement("div")
      );
    }
    default:
      return createElement(Component, props, children);
  }
}

/** @description A strictly validated, html input */
const Input = forwardRef(
  (
    {
      /* html global elelement attributes */
      id,
      // inputMode,
      // tabIndex, // with great power comes great responsibility
      // title,
      /* html input-specific attributes */
      // accept,
      // alt,
      autoComplete,
      // autoFocus, // don't use this please please please
      // capture,
      checked,
      // dirname,
      disabled,
      form,
      // formAction, // old-school html form submission
      // formEncType, // old-school html form submission
      // formMethod, // old-school html form submission
      formNoValidate,
      // formTarget, // old-school html form submission
      // height,
      // list,
      max,
      maxLength,
      min,
      minLength,
      multiple,
      name,
      pattern,
      placeholder,
      readOnly,
      required,
      size,
      // src,
      step,
      type,
      value,
      /* react attributes */
      children,
      className,
      defaultChecked,
      defaultValue,
      //   autoFocus,
      style,
      /* react synthetic events */
      onBlur,
      onChange,
      onClick,
      onFocus,
      onInput,
      onInvalid,
    },
    ref
  ) => {
    return inputElementPragma(
      "input",
      {
        /* html global elelement attributes */
        id,
        // inputMode,
        // tabIndex,
        // title,
        /* html input-specific attributes */
        // accept,
        // alt,
        autoComplete,
        // autoFocus,
        // capture,
        checked,
        // dirname,
        disabled,
        form,
        // formAction, // old-school html form submission
        // formEncType, // old-school html form submission
        // formMethod, // old-school html form submission
        formNoValidate,
        // formTarget, // old-school html form submission
        // height,
        // list,
        max,
        maxLength,
        min,
        minLength,
        multiple,
        name,
        pattern,
        placeholder,
        readOnly,
        required,
        size,
        // src,
        step,
        type,
        value,
        /* react attributes */
        className,
        defaultChecked,
        defaultValue,
        ref,
        style,
        /* react synthetic events */
        onBlur,
        onChange,
        onClick,
        onFocus,
        onInput,
        onInvalid,
      },
      children
    );
  }
);

Input.propTypes = {
  /* html global elelement attributes */
  id: PropTypes.string,
  // inputMode: PropTypes.tring,
  // tabIndex: PropTypes.number,
  // title: PropTypes.string,
  /* html input-specific attributes */
  // accept: PropTypes.oneOfType([
  //   PropTypes.string,
  //   PropTypes.arrayOf(PropTypes.string),
  // ]),
  // alt: PropTypes.string,
  autoComplete: PropTypes.string,
  // autoFocus: PropTypes.bool, // don't use this please please please
  // capture: PropTypes.string,
  checked: PropTypes.bool,
  // dirname: PropTypes.string,
  disabled: PropTypes.bool,
  form: PropTypes.string,
  // formAction: PropTypes.string, // old-school html form submission
  // formEncType: PropTypes.string, // old-school html form submission
  // formMethod: PropTypes.string, // old-school html form submission
  formNoValidate: PropTypes.bool,
  // formTarget: PropTypes.string, // old-school html form submission
  // height: PropTypes.string,
  // list: PropTypes.string,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  minLength: PropTypes.number,
  multiple: PropTypes.bool,
  name: PropTypes.string.isRequired,
  pattern: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  size: PropTypes.number,
  // src: PropTypes.string,
  step: PropTypes.number,
  type: PropTypes.oneOf([
    "button",
    "checkbox",
    "color",
    "date",
    "datetime-local",
    "email",
    "file",
    "hidden",
    "image",
    "month",
    "number",
    "password",
    "radio",
    "range",
    "reset",
    "search",
    "submit",
    "tel",
    "text",
    "time",
    "url",
    "week",
  ]).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  /* react attributes */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  style: PropTypes.object,
  /* react synthetic events */
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onInput: PropTypes.func,
  onInvalid: PropTypes.func,
};

const applyDefaultAndShadowedStyles = ({ type }) => styles[type] || "";
const StyledInput = styled(Input)([""], applyDefaultAndShadowedStyles);

export { StyledInput as Input };
